const INITIAL_DATA = {
    authToken: localStorage.getItem("authToken") || false,
    me: {
        __typename: 'User',
        id: null,
        locale: "de",
    }
};

export default INITIAL_DATA;